import React from "react";
import useInView from "../../../hooks/useInView";
import "./TarjetaDeServicioMigracion.css";

interface Service {
  title: string;
  desc: string;
}

interface TarjetaDeServicioMigracionProps {
  service: Service;
  delay?: number;
  animationClass?: string;
}

export default function TarjetaDeServicioMigracion({ service, delay = 0, animationClass = "" }: TarjetaDeServicioMigracionProps) {
  const [ref, inView] = useInView({ threshold: 0.3 });

  return (
    <div
      ref={ref}
      className={`service-card animate-card${inView ? " visible" : ""} ${animationClass}`}
      style={{ transitionDelay: `${delay}s` }}
    >
      <h3 className="service-migracion-title">{service.title}</h3>
      <p className="service-migracion-text">{service.desc}</p>
    </div>
  );
}